var React = require('react');

function PFFBrandIconsSocialSharingLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"linkedin","d":"M644,0H76C36.3,0,4.2,32.2,4.2,72v576c0,39.8,32.1,72,71.7,72H644c39.6,0,71.7-32.2,71.7-72V72\n\tC715.8,32.2,683.7,0,644,0z M232.5,569.7h-95.7v-308h95.7V569.7z M184,223.9c-30.2,0-49.8-21.4-49.8-47.9c0-27.1,20.2-47.9,51-47.9\n\tc30.9,0,49.8,20.8,50.4,47.9C235.7,202.5,216.2,223.9,184,223.9z M582.1,569.7h-95.7V399c0-39.7-13.9-66.8-48.5-66.8\n\tc-26.5,0-42.2,18.3-49.1,35.9c-2.5,6.3-3.2,15.1-3.2,23.9v177.6h-95.7V360c0-38.4-1.3-70.5-2.5-98.3h83.1l4.4,42.8h1.9\n\tc12.6-20.2,43.5-49.8,95.1-49.8c63,0,110.2,42.2,110.2,132.9V569.7z"}));
}

PFFBrandIconsSocialSharingLinkedin.defaultProps = {"version":"1.1","id":"Icon","x":"0px","y":"0px","viewBox":"0 0 720 720","style":{"enableBackground":"new 0 0 720 720"},"xmlSpace":"preserve"};

module.exports = PFFBrandIconsSocialSharingLinkedin;

PFFBrandIconsSocialSharingLinkedin.default = PFFBrandIconsSocialSharingLinkedin;
